import React from "react";
// import RcTree from '../../_rc-tree-1.13.2/src';
import animation from "../_util/openAnimation";
import Loadable from "../../react-loadable";
const RcTree = Loadable({
  loader: () => import("../../_rc-tree-1.13.2/src"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
import TreeNode from "../../_rc-tree-1.13.2/src/TreeNode";
export default class Tree extends React.Component {
  // static TreeNode = RcTree.TreeNode;
  static TreeNode = TreeNode;

  static defaultProps = {
    prefixCls: "ant-tree",
    checkable: false,
    showIcon: false
    // openAnimation: animation,
  };

  render() {
    const props = this.props;
    let checkable = props.checkable;
    if (checkable) {
      checkable = <span className={`${props.prefixCls}-checkbox-inner`} />;
    }
    return (
      <RcTree {...props} checkable={checkable}>
        {this.props.children}
      </RcTree>
    );
  }
}



// WEBPACK FOOTER //
// ./_antd1.11.2/tree-new/index.jsx